export default (s) => {
  if (!s || typeof s !== 'string') {
    return '';
  }
  return s.split(/\s+/).map((chunk) => `${(chunk[0] || '').toUpperCase()}${chunk.substring(1)}`).join(' ');
};
